import React, { useState } from "react";

export default function ImageTile({
  src,
  alt,
  emoji,
  className = "",
  imgClassName = "",
  overlayClassName = "",
  fallbackGradient = "from-emerald-700/60 to-emerald-950/80",
  children,
}) {
  const [failed, setFailed] = useState(false);

  return (
    <div className={`relative overflow-hidden ${className}`}>
      {!failed ? (
        <img
          src={src}
          alt={alt}
          loading="lazy"
          decoding="async"
          fetchPriority="low"
          onError={() => setFailed(true)}
          className={`absolute inset-0 w-full h-full object-cover transition duration-700 ${imgClassName}`}
          style={{ contentVisibility: "auto" }}
        />
      ) : (
        <div
          className={`absolute inset-0 bg-gradient-to-br ${fallbackGradient} flex items-center justify-center text-5xl`}
        >
          {emoji}
        </div>
      )}
      <div
        className={`absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent ${overlayClassName}`}
      />
      {children}
    </div>
  );
}
